import React from 'react'
import {ExtraSmallButton} from '../custom'
import {useUndoRedoContext} from './UndoRedo.context'
import UndoIcon from "../../assets/icons/UndoIcon";
import RedoIcon from "../../assets/icons/RedoIcon";
import { Stack } from '@mui/material';

const UndoRedoButtons = () => {
    const {undo, redo, canRedo, canUndo} = useUndoRedoContext()
    return (
        <Stack direction={'row'} justifyContent={'center'} alignItems={'center'}>
            <ExtraSmallButton aria-label="Undo" data-event={'Undo Clicked'}
                              data-event-source={'stockbar'} size={"small"} color="inherit" onClick={undo} disabled={!canUndo}>
                <UndoIcon fontSize={'small'}/>
            </ExtraSmallButton>
            <ExtraSmallButton aria-label="Redo" data-event={'Redo Clicked'}
                              data-event-source={'stockbar'} size={"small"} color="inherit" onClick={redo} disabled={!canRedo}>
                <RedoIcon fontSize={'small'}/>
            </ExtraSmallButton>
        </Stack>
    )
}
export default UndoRedoButtons